import { Link } from "react-router-dom";
import { logoWhiteUrl, publicAsset } from "../utils/publicAssets";
import "./NewFooter.css";

const socials = [
  { name: "LinkedIn", icon: "/Image Assets/footer-icons/linkedin-svgrepo-com.svg", link: "https://www.linkedin.com/company/sapphire-school-of-diplomacy/" },
  { name: "Twitter", icon: "/Image Assets/footer-icons/twitter-x.svg", link: "https://www.twitter.com" },
  { name: "Facebook", icon: "/Image Assets/footer-icons/facebook-svgrepo-com.svg", link: "https://www.facebook.com/share/1AgEjtDjKs/" },
  { name: "Ticktok", icon: "/Image Assets/footer-icons/tiktok-svgrepo-com.svg", link: "https://www.tiktok.com" },
  { name: "Instagram", icon: "/Image Assets/footer-icons/instagram-167-svgrepo-com.svg", link: "https://www.instagram.com" },
  { name: "Youtube", icon: "/Image Assets/footer-icons/youtube-svgrepo-com.svg", link: "https://youtube.com/@eusbdmalta?si=0gm8fPR7ITIPWyO9" },
];

const sections = [
  {
    title: "Quick Links",
    links: [
      { text: "Home", url: "/" },
      { text: "Admission", url: "/admissions" },
      { text: "Directory", url: "/directory" },
      { text: "About", url: "/about/our-institution" },
      { text: "Contact", url: "mailto:admissions@eusbd.eu" },
      { text: "Ask a Question", url: "https://enquiry.eusbd.eu/", enquiryHub: true },
      { text: "Login", url: "https://elearn.eusbd.eu/" },
    ],
  },
  {
    title: "Partnerships",
    links: [
      { text: " Become a Study Centre Partner", url: "/study-centre-partner" },
      { text: "Corporate Partnership", url: "/corporate-partnership" },
    ],
  },
  {
    title: "About Us",
    links: [
      { text: "Our Institution", url: "/about/our-institution" },
      { text: "Message from the President", url: "/about/message-president" },
      { text: "Head Of School & Staff", url: "/about/executive-team/2" },
      { text: "Programme Consultant", url: "/about/executive-team/3" },
      { text: "Student Complaint Form", url: "/student-complaint-form" },
      { text: "Accreditation", url: "/about/accreditation" },
      { text: "Governance", url: "/about/executive-team" },
    ],
  },
  {
    title: "Policies",
    links: [
      { text: "Privacy Policy", url: "/privacy-policy" },
      { text: "ESBD Code Of Ethics", url: "/documents/ESBD Code of Ethics.pdf" },
      { text: "ESBD Information and data Protection", url: "/documents/ESBD Information Management Data Protection Policy.pdf" },
      { text: "ESBD Tuition Fee Refund And Withdrawal Policy", url: "documents/ESBD_Tuition_Fee_Refund_and_Withdrawal_Policy.pdf" },
      { text: "Digital Learning & Engagement Management Protocol", url: "/documents/ESBD Digital Learning Engagement Management Protocol.pdf" },
      { text: "Learning Resources and Virtual Facilities Management Policy", url: "documents/Learning_Resources_and_Virtual_Facilities_Management_Policy.pdf" },
      { text: "Online Library and Academic Resource Access Policy", url: "documents/Online_Library_and_Academic_Resource_Access_Policy.pdf" },
      { text: "Admissions and Student Enrolment Policy", url: "/documents/ESBD Admissions and Student Enrolment Policy ASEP.pdf" },
      { text: "Quality Management Policy Document", url: "/documents/ESBD Quality Management Policy Document.pdf" },
      { text: "Internal Quality Assurance Standards Manual", url: "/documents/Internal Quality Assurance Standards Manual.pdf" },
      { text: "Student Handbook and Learning Guide", url: "/documents/ESBD Student Handbook and Learning Guide.pdf" },
    ],
  },
];

const locationText = "241 Tower Business Centre \n2nd FloorTriq it- Torri Swatar \nBirkirkara BKR 4013 Malta Europe";
const locationUrl = "https://maps.google.com/?q=241+Tower+Business+Centre,+Birkirkara,+Malta";
const email = "admissions@eusbd.eu";

const contactMethods = [
  { name: "Email", icon: "/Image Assets/footer-icons/email-svgrepo-com.svg", link: "mailto:contact@yourcompany.com" },
  { name: "Map", icon: "/Image Assets/footer-icons/map-pin-alt-svgrepo-com.svg", link: "https://maps.google.com" },
];

function isExternal(href) {
  return href.startsWith("http") || href.startsWith("mailto:");
}

export default function NewFooter() {
  return (
    <footer className="th-footer">
      <div className="th-footer__inner">
        <div className="th-footer__top">
          <div className="th-footer__brand">
            <Link to="/" className="th-footer__logo">
              <img src={logoWhiteUrl} alt="ESBD" />
            </Link>
            <p className="th-footer__tagline">
              A Malta-based higher education institution preparing future leaders through flexible, internationally focused programmes.
            </p>
            <div className="th-footer__socials">
              {socials.map((s, i) => (
                <a key={i} href={s.link} className="th-footer__social" target="_blank" rel="noopener noreferrer" aria-label={s.name}>
                  <img src={publicAsset(s.icon)} alt="" loading="lazy" />
                </a>
              ))}
            </div>
            <div className="th-footer__contact-us">
              <h4>Contact Us</h4>
              <div className="th-footer__contact-btns">
                {contactMethods.map((method, i) => (
                  <a key={i} href={method.link} className="th-footer__contact-btn" target="_blank" rel="noopener noreferrer" aria-label={method.name}>
                    <img src={publicAsset(method.icon)} alt="" loading="lazy" />
                  </a>
                ))}
              </div>
            </div>

            <div className="th-footer__contact">
              <div className="th-footer__ci">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" strokeWidth="1.5" /><circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="1.5" /></svg>
                <a href={locationUrl} target="_blank" rel="noopener noreferrer">{locationText}</a>
              </div>
              <div className="th-footer__ci">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" /><path d="M2 7l10 6 10-6" stroke="currentColor" strokeWidth="1.5" /></svg>
                <a href={`mailto:${email}`}>{email}</a>
              </div>
            </div>
          </div>

          {sections.map((sec, idx) => (
            <div key={idx} className="th-footer__col">
              <h4>{sec.title}</h4>
              {sec.links.map((link, i) => {
                if (link.enquiryHub) {
                  return (
                    <span key={i} className="th-footer__link-wrap">
                      <a href={link.url} className="th-footer__enquiry" target="_blank" rel="noopener noreferrer">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                          <circle cx="12" cy="12" r="10" />
                          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                          <line x1="12" y1="17" x2="12.01" y2="17" />
                        </svg>
                        {link.text}
                      </a>
                    </span>
                  );
                }
                const external = isExternal(link.url);
                const isPdf = link.url.toLowerCase().endsWith(".pdf");
                const content = <>{link.text}</>;
                const openNewTab = external || isPdf;
                return (
                  <span key={i} className="th-footer__link-wrap" style={{ whiteSpace: "pre-line" }}>
                    {openNewTab ? (
                      <a
                        href={isPdf ? publicAsset(encodeURI(link.url)) : link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {content}
                      </a>
                    ) : (
                      <Link to={link.url}>{content}</Link>
                    )}
                  </span>
                );
              })}
            </div>
          ))}

        </div>

        <div className="th-footer__bottom">
          <span className="th-footer__copy">
            &copy; {new Date().getFullYear()} The European School of Business &amp; Diplomacy.
          </span>
        </div>
      </div>
    </footer>
  );
}
